module.exports = __webpack_public_path__ + "static/media/houniao-1@2x.1d71d993.png";